import type { BackendRouteDefinition } from '../types';

// Flipped from `transport: 'callable'` to `transport: 'api'` by S5-WB1
// (PRA-792). Now served by `api-core-node` at
// `POST /api/firms/payments/merchants:lookup`. The legacy
// `getAllMerchantInfoForFirm` callable continues to exist in
// `cloudFunctions/` so any deployed firms app version still holding the old
// route table can fall back to it; retirement of the callable export is
// deferred to S9-WB2.

export const getAllMerchantInfoForFirmRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/payments/merchants:lookup',
} as const satisfies BackendRouteDefinition;
